export default "__VITE_ASSET__ILhQHbIG__"